import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=fb3c745e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=fb3c745e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3c745e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3c745e')) {
      api.createRecord('fb3c745e', component.options)
    } else {
      api.reload('fb3c745e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=fb3c745e&scoped=true&", function () {
      api.rerender('fb3c745e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UrN8dzY3UzZZ/JS/comp/SearchFilterTokens.vue"
export default component.exports